import type { KyrgyzstanOwnerOrder } from 'shared/api/kyrgyzstan/webview-owner'
import { DATE_FORMAT_LIST } from 'shared/constants/dateFormatList'
import { dateFormat } from 'shared/lib/dateFormat'

import type { ObjectBooking, ObjectBookingStatus } from './types'

export const mapOwnerOrderToObjectBooking = (
  order: KyrgyzstanOwnerOrder,
): ObjectBooking => ({
  id: order.id,
  status: order.status as ObjectBookingStatus,
  statusLabel: order.status_label,
  title: order.object.title,
  address: order.object.address,
  startDate: dateFormat(
    order.start_date,
    DATE_FORMAT_LIST.FULL_DATE_SHORT_YEAR,
  ),
  endDate: dateFormat(order.end_date, DATE_FORMAT_LIST.FULL_DATE_SHORT_YEAR),
  nightsCount: order.nights,
  guestsCount: order.visitors_count,
})
